<template>
  <div class="row">
    <div class="col-md-12">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" @click="$parent.showIndividualStats = false">Ticket laod Stats</a>
          </li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)" @click="selectedAdmin = null">Staff List</a>
          </li>
          <li v-if="selectedAdmin" class="breadcrumb-item">
            <a href="javascript:void(0)">
              <img :src="`https://www.gravatar.com/avatar/${emailHashGravatar(selectedAdmin.email)}?s=50`"
                   class="rounded-circle mr-4"
                   width="20px">
              <span>
                {{ selectedAdmin.firstName }}
              </span>
            </a>
          </li>
        </ol>
      </nav>
    </div>
    <template v-if="!selectedAdmin">
      <div class="col-md-12 d-flex justify-content-center align-items-center">
        <h5 class="fw-600">Staff List</h5>
      </div>
      <div v-for="(row, index) in modifiedShifts" :key="index" class="col-md-2 col-sm-6 mb-4"
           @click="selectedAdmin = row">
        <div class="admin-card card text-center shadow-sm border-0">
          <img :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=200`" alt="Admin Avatar"
               class="card-img-top rounded-circle mx-auto mt-3"
               style="width: 100px; height: 100px; object-fit: cover;">
          <div class="card-body">
            <h6 class="card-title mb-0">{{ `${row.firstName} ${row.lastName}` }}</h6>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-md-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
                id="performance-tab"
                aria-controls="performance"
                class="nav-link active"
                data-toggle="tab"
                href="#performance"
                role="tab"
            >Performance</a>
          </li>
          <li class="nav-item">
            <a
                id="leaveStats-tab"
                aria-controls="leaveStats"
                class="nav-link"
                data-toggle="tab"
                href="#leaveStats"
                role="tab"
                @click="tab = 1"
            >Leave Stats</a>
          </li>
        </ul>
      </div>
      <div class="col-md-12 d-flex justify-content-center tab-content customer-table">
        <div id="performance" aria-labelledby="performance-tab" class="tab-pane fade show active col-md-6"
             role="tabpanel"
        >
          <h5 class="text-center fw-600 mt-10">Performance Stats</h5>
          <div>
            <label class="typo__label">Start Date</label>
            <input v-model="start" :disabled="!selectedAdmin" :max="todaysDate" class="form-control" min="2025-01-01"
                   type="date">
          </div>
          <div>
            <label class="typo__label">End Date</label>
            <input v-model="end" :disabled="!selectedAdmin || !start" :max="todaysDate" :min="start"
                   class="form-control" type="date">
          </div>
          <div>
            <button :disabled="!selectedAdmin || !start || !end" class="btn btn-sm btn-primary" @click="fetchData">
              Submit
            </button>
          </div>
          <div v-show="allAdminStats.length" class="col-md-12 col-lg-12 col-md-12 mb-20">
            <div v-if="chartLoading" class="card d-flex flex-column justify-content-center align-items-center"
                 style="height: 600px;">
              <div class="loader"></div>
              <span class="fw-600">Loading Ticket Load Chart...</span>
            </div>
            <div v-show="!chartLoading" ref="chartContainer"
                 style="width: 100%; height: 600px; border-radius: 12px">
            </div>
            <template v-if="modifiedOneDayStats.length > 0">
              <p v-if="selectedAdmin && start && rangeLabel.length === 1 && !getShift.type"
                 class="weekend mt-20 d-flex justify-content-center">According to the staff’s
                schedule, this is marked as a weekend </p>
              <template v-else>
                <div class="col-md-12 d-flex justify-content-center mt-10">
                  <h6>Shift Timings: {{ `${getShift.shiftIn} EST - ${getShift.shiftOut} EST` }}</h6>
                </div>
                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr>
                    <th>Time</th>
                    <th class="text-center">Mode</th>
                    <th class="text-center">Stats</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in modifiedOneDayStats" :key="index">
                    <td>
                      {{ row.time }}
                    </td>
                    <td class="text-center" width="50%">
                      <span v-html="getOffDeskMin({time: row.time, ...row.ticketStats})"></span>
                    </td>
                    <td class="text-center" width="25%">
                      <template v-if="row.ticketStats">
                        <span><b>Tickets Handled:</b> {{ row.ticketStats.tickets_handled || 0 }} </span><br>
                        <span><b>Count Replies:</b> {{ row.ticketStats.count_replies || 0 }}</span><br>
                      </template>
                      <span v-if="row.monitorStats">
                   <b>Monitors Handled:</b> {{ row.monitorStats.count || 0 }}
                  </span>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td class="text-right" colspan="3">
                      <span>Total Tickets Handled: {{ getTotalStats.tickets_handled }}</span><br>
                      <span>Total Count Replies: {{ getTotalStats.count_replies }}</span><br>
                      <span>Total Monitor Handled: {{ getTotalStats.monitors_handled }}</span>
                    </td>
                  </tr>
                  </tfoot>
                </table>
              </template>
            </template>
            <template v-else-if="modifiedSevenDayStats.length > 0">
              <template>
                <table class="table table-bordered">
                  <thead class="thead-dark">
                  <tr>
                    <th>Time</th>
                    <th class="text-center">Mode</th>
                    <th class="text-center">Stats</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in modifiedSevenDayStats" :key="index">
                    <td>
                      {{ row.date }}
                    </td>
                    <td class="text-center flex-column" width="50%">
                      <span><b>Active 👨‍💻:</b> {{ getHrs(row.modes.active) }} hrs<br></span>
                      <span v-if="getBreakMinutesPerDays(row.breaks).break"><b>Break <i class="fa fa-coffee"
                                                                                        style="color: saddlebrown"></i>:</b> {{
                          getBreakMinutesPerDays(row.breaks).break
                        }} hrs<br></span>
                      <span v-if="getBreakMinutesPerDays(row.breaks).performance"><b>Performance <i
                          class="fa fa-bolt text-warning"></i>:</b> {{ getBreakMinutesPerDays(row.breaks).performance }} hrs<br></span>
                      <span v-if="getBreakMinutesPerDays(row.breaks).engineering"><b>Engineering <i
                          class="fa fa-laptop"
                          style="color: saddlebrown"></i>:</b> {{
                          getBreakMinutesPerDays(row.breaks).engineering
                        }} hrs<br></span>
                      <span v-if="getBreakMinutesPerDays(row.breaks).meeting"><b>Meeting <i class="fa fa-headphones"
                                                                                            style="color: grey"></i>::</b> {{
                          getBreakMinutesPerDays(row.breaks).meeting
                        }} hrs<br></span>
                      <span v-if="getBreakMinutesPerDays(row.breaks).other"><b>Other  <i class="fa fa-wrench"
                                                                                         style="color: black"></i>:</b> {{
                          getBreakMinutesPerDays(row.breaks).other
                        }} hrs<br></span>
                    </td>
                    <td class="text-center" width="25%">
                      <span><b>Tickets Handled:</b> {{ row.tickets_handled || 0 }} </span><br>
                      <span><b>Count Replies:</b> {{ row.count_replies || 0 }}</span><br>
                      <br><b>Monitors Handled:</b> {{ row.monitors_handled || 0 }}
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td class="text-right" colspan="3">
                      <span>Total Tickets Handled: {{ getTotalStatsPerDays.tickets_handled }}</span><br>
                      <span>Total Count Replies: {{ getTotalStatsPerDays.count_replies }}</span><br>
                      <span>Total Monitor Handled: {{ getTotalStatsPerDays.monitors_handled }}</span>
                    </td>
                  </tr>
                  </tfoot>
                </table>
              </template>
            </template>
          </div>
        </div>
        <div id="leaveStats" aria-labelledby="leaveStats-tab" class="tab-pane fade col-md-12" role="tabpanel">
          <h5 class="text-center fw-600 mt-10">Leave Stats</h5>
          <div class="d-flex">
            <div class="card" style="background: #f2f2f2; width: 20%">
              <div class="card-body d-flex align-items-center">
                <div class="col-12 col-md-12">
                  <div class="numbers d-flex flex-column">
                    <p class="card-category text-success fw-600 fs-18">
                      Approved Leaves ({{ year }})
                    </p>
                    <p class="card-title">{{ getApprovedLeaves }}</p>
                    <p>
                    </p></div>
                </div>
              </div>
            </div>
            <div class="card ml-10" style="background: #f2f2f2; width: 20%">
              <div class="card-body d-flex align-items-center">
                <div class="col-12 col-md-12">
                  <div class="numbers d-flex flex-column">
                    <p class="card-category text-warning fw-600 fs-18">
                      Pending Leaves ({{ year }})
                    </p>
                    <p class="card-title">{{ getPendingLeaves }}</p>
                    <p>
                    </p></div>
                </div>
              </div>
            </div>
            <div class="card ml-10" style="background: #f2f2f2; width: 20%">
              <div class="card-body d-flex align-items-center">
                <div class="col-12 col-md-12">
                  <div class="numbers d-flex flex-column">
                    <p class="card-category text-info fw-600 fs-18">
                      Work Event Leaves ({{ year }})
                    </p>
                    <p class="card-title">{{ getWorkEventLeaves }}</p>
                    <p>
                    </p></div>
                </div>
              </div>
            </div>
            <div class="card ml-10" style="background: #f2f2f2; width: 20%">
              <div class="card-body d-flex align-items-center">
                <div class="col-12 col-md-12">
                  <div class="numbers d-flex flex-column">
                    <p class="card-category text-default fw-600 fs-18">
                      Withdrawn Leaves ({{ year }})
                    </p>
                    <p class="card-title">{{ getWithdrawLeaves }}</p>
                    <p>
                    </p></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <label for="">Year</label>
            <select v-model="year" class="form-control mb-10" style="width: 200px">
              <option value="all">All</option>
              <option value="2025">2025</option>
            </select>
          </div>
          <table :id="'tableId'" class="table table-bordered">
            <thead class="table-light">
            <tr>
              <th class="text-center">Leave Type</th>
              <th class="text-center">Dates</th>
              <th class="text-center">Duration</th>
              <th class="text-center">Details</th>
              <th class="text-center">Status</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in allLeaves" :key="index">
              <td class="text-center">{{ leaveTypes[row.leaveType] }}</td>
              <td class="text-center" width="15%">
            <span v-if="row.leaveType !== 'partialLeave'">
              {{
                row.leaveDays && row.leaveDays.length > 1 ? `${parseDate(row.start)} &nbsp - &nbsp ${parseDate(row.end)}` : parseDate(row.start)
              }}
            </span>
                <span v-else>{{ parseDate(row.partialLeave.date) }} <span
                    class="text-danger fw-600">({{ row.partialLeave.from }} - {{ row.partialLeave.to }})</span></span>
              </td>
              <td class="text-center">
                <span v-if="row.leaveType === 'workEvent'">Not eligible to count</span>
                <span v-else-if="row.leaveType !== 'partialLeave'">
                {{ row.leaveDays && row.leaveDays.length > 0 ? row.leaveDays.length : '-' }}
              </span>
                <span v-else-if="row.leaveType === 'partialLeave'">
                {{ getDuration(row) }} (hrs)
              </span>
              </td>
              <td class="text-center" width="20%">
                <span :id="`leaves_${index}`" :style="!row.details ? 'opacity: 0.5;' : ''"
                      class="make-cursor-pointer" @mouseleave="getTitle(row, false, index)"
                      @mouseover="getTitle(row, true, index)">{{
                    row.details && row.details.length > 500 ? row.details.substring(0, 500) + '...' : row.details || 'N/A'
                  }}</span>
              </td>
              <td class="text-center">
                <span :class="getStatusClass(row.status)" class="badge badge-pill">{{ row.status }}</span>
              </td>
            </tr>
            </tbody>
          </table>

        </div>

      </div>
    </template>
  </div>
</template>

<script>
import md5 from "crypto-js/md5";
import moment from "moment-timezone";
import {db} from "@/firebase/init";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

export default {
  name: "staffStats",
  components: {},
  props: {
    modifiedShifts: {
      type: Array
    }
  },
  data() {
    return {
      leaveTypes: {
        'sick': 'Sick',
        'pto': 'PTO',
        'vacation': 'Vacation',
        'partialLeave': 'Partial Leave',
        'workEvent': 'Work Event',
      },
      tab: 0,
      todaysDate: moment().tz('America/New_York').format('YYYY-MM-DD'),
      chartLoading: false,
      selectedAdmin: null,
      allLeaves: [],
      start: "",
      end: '',
      rangeLabel: [],
      oneDayStats: [],
      sevenDayStats: [],
      allAdminStats: [],
      chart: {
        type: 'bar'
      },
      year: moment().tz('America/New_York').format('YYYY')
    }
  },
  computed: {
    getApprovedLeaves() {
      const array = this.allLeaves.filter(leave => leave.status === 'approved' && leave.leaveType !== 'workEvent')
      let totalLeaveCount = 0
      let partialTime = 0
      for (const row of array) {
        if (row.leaveType === 'partialLeave') {
          if (!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if (el.includes(this.year)) {
              totalLeaveCount++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime / 60) / 8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    getWorkEventLeaves() {
      const array = this.allLeaves.filter(leave => leave.status === 'approved' && leave.leaveType === 'workEvent')
      let totalLeaveCount = 0
      let partialTime = 0
      for (const row of array) {
        if (row.leaveType === 'partialLeave') {
          if (!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if (el.includes(this.year)) {
              totalLeaveCount++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime / 60) / 8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    getPendingLeaves() {
      const array = this.allLeaves.filter(leave => leave.status === 'pending')
      return array.length
    },
    getRejectedLeaves() {
      const array = this.allLeaves.filter(leave => leave.status === 'rejected')
      let totalLeaveCount = 0
      let partialTime = 0
      for (const row of array) {
        if (row.leaveType === 'partialLeave') {
          if (!row.partialLeave.date.includes(this.year)) continue
          const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
          const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
          const diffInMs = toTime - fromTime;
          const totalMinutes = Math.abs(diffInMs / (1000 * 60));
          partialTime = partialTime + totalMinutes
          console.log('partial time', row.partialLeave, partialTime)
        } else {
          row.leaveDays.map(el => {
            if (el.includes(this.year)) {
              totalLeaveCount++
            }
          })
        }
      }
      console.log('totalLeaveCount', totalLeaveCount)
      totalLeaveCount = totalLeaveCount + Number(partialTime / 60) / 8
      return totalLeaveCount > 0 ? totalLeaveCount.toFixed(2) : 0
    },
    getWithdrawLeaves() {
      const array = this.allLeaves.filter(leave => leave.status === 'withdrawn')
      return array.length
    },
    staff() {
      return this.modifiedShifts
    },
    xCategories() {
      return this.modifiedShifts.map(el => `${el.firstName} ${el.lastName}`)
    },
    getTotalStats() {
      let tickets_handled = 0
      let count_replies = 0
      let monitors_handled = 0
      this.modifiedOneDayStats.map(item => {
        if (item.ticketStats) {
          tickets_handled += item.ticketStats.tickets_handled || 0
          count_replies += item.ticketStats.count_replies || 0
        }
        if (item.monitorStats) {
          monitors_handled += item.monitorStats.count || 0
        }
      })
      return {tickets_handled, count_replies, monitors_handled}
    }, getTotalStatsPerDays() {
      let tickets_handled = 0
      let count_replies = 0
      let monitors_handled = 0
      this.modifiedSevenDayStats.map(item => {
        tickets_handled += item.tickets_handled || 0
        count_replies += item.count_replies || 0
        monitors_handled += item.monitors_handled || 0
      })
      return {tickets_handled, count_replies, monitors_handled}
    },
    getShift() {
      return this.selectedAdmin ? this.selectedAdmin.shifts[this.currentDay(this.start)] : {}
    },
    modifiedSevenDayStats() {
      return this.sevenDayStats.sort((a, b) => new Date(a.date) - new Date(b.date));
    },
    modifiedOneDayStats() {
      if (this.oneDayStats.length === 0) {
        return []
      }
      const toMinutes = time => {
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
      };

      const shiftStartMin = toMinutes(this.getShift.shiftIn);
      const shiftEndMin = toMinutes(this.getShift.shiftOut);

      return this.oneDayStats.filter(time => {
        const hourStartMin = toMinutes(time.time);
        const hourEndMin = hourStartMin + 60;

        // Overnight shift
        if (shiftEndMin < shiftStartMin) {
          // Shift goes over midnight
          return (
              hourEndMin > shiftStartMin || hourStartMin < shiftEndMin
          );
        } else {
          // Same-day shift
          return (
              hourEndMin > shiftStartMin && hourStartMin < shiftEndMin
          );
        }
      });
    }
  },
  watch: {
    allLeaves() {
      this.renderDatatable()
    },
    tab(val) {
      if (val === 1) {
        this.fetchLeaves()
      }
    },
    selectedAdmin() {
      if (this.start && this.end) {
        // this.fetchData()
      }
      this.fetchLeaves()
    },
    start() {
      if (this.end) {
        this.calculateTotalDays(this.start, this.end)
      }
    },
    end(val) {
      if (this.start) {
        this.calculateTotalDays(this.start, this.end)
      }
    },
  },
  methods: {
    renderDatatable(id) {
      if ($.fn.DataTable.isDataTable('#tableId')) {
        $(`#tableId`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#tableId`).dataTable({
          pagingType: "full_numbers",
          ordering: false,
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo": false,
        });
      }, 0)
    },
    getTitle(row, flag, index) {
      if (!flag || !row.details) {
        return true
      }
      tippy(`#${this.selectedTab}_${index}`, {
        content: row.details,
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    getDuration(row) {
      let partialTime = 0
      const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
      const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
      const diffInMs = toTime - fromTime;
      const totalMinutes = Math.abs(diffInMs / (1000 * 60));
      partialTime = partialTime + totalMinutes
      return Number(partialTime / 60)
    },
    getStatusClass(status) {
      let statusClass = '';
      if (status === 'pending') {
        statusClass = 'badge-warning';
      } else if (status === 'approved') {
        statusClass = 'badge-success';
      } else if (status === 'rejected') {
        statusClass = 'badge-danger';
      } else if (status === 'withdrawn') {
        statusClass = 'badge-default';
      }
      return statusClass;
    },
    parseDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    async fetchLeaves() {
      this.allLeaves = []
      const ref = await db.collection('leaveRecords').where('email', '==', this.selectedAdmin.email).get();
      console.log('leave records', ref.size)
      if (ref.size) {
        ref.forEach(el => {
          this.allLeaves.push({...el.data()})
        })
        this.allLeaves = this.allLeaves.sort((a, b) => {
          return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        })
      }
    },
    initChart() {
      this.chartLoading = true
      const categories = JSON.parse(JSON.stringify(this.xCategories))
      console.log('categories', categories)
      const vm = this;
      const barChart = {
        chart: {
          type: 'column'
        },
        title: {
          text: `Ticket & Monitor Load Stats (${moment(this.start).format('MMM DD, YYYY')} - ${moment(this.end).format('MMM DD, YYYY')})`
        },
        xAxis: {
          categories,
          title: {
            text: 'Staff Members'
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total Stats',
            align: 'high'
          }
        },
        tooltip: {
          formatter: function (val) {
            console.log('vm', vm, val)
            const obj = vm.staff.find(el => categories[this.x] === `${el.firstName} ${el.lastName}`)
            console.log('obj', obj)
            const stat = vm.getAdminTotalStats(obj)
            return `Total Tickets Handled: ${stat.tickets_handled}<br> Total Count Replies: ${stat.count_replies}<br> Total Monitors Handled: ${stat.monitors_handled}`
          }
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function () {
                  vm.openStaffDetails(vm.ticketStats, `${this.category.includes('LIVE') ? `${vm.dateTime.split(':')[0]}:00` : this.category}`)
                }
              }
            }
          },
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        series: [{
          data: []
        }]
      }
      for (const [i, row] of this.staff.entries()) {
        const {monitors_handled, tickets_handled, count_replies} = this.getAdminTotalStats(row)
        barChart.series[0].data.push({
          y: monitors_handled + tickets_handled + count_replies,
          color: row.email === this.selectedAdmin.email ? '#33CD40' : '#000'
        });
      }

      console.log('series data', barChart.series[0].data);

      Highcharts.setOptions({
        time: {
          timezone: 'America/New_York'
        }
      });

      Highcharts.chart(this.$refs.chartContainer, {...barChart}, () => {
        console.log('Chart loaded from callback');
        this.chartLoading = false;
      });
      this.chartLoading = false
    },
    getHrs(minutes) {
      return (minutes / 60).toFixed(2)
    },
    getBreakMin(row, type) {
      console.log('row', row)
      const targetHour = row.time
      if (!row.breaks) {
        return ''
      }
      console.log('targetHour', targetHour, row)
// Build time range in EST
      const hourStartEST = moment.tz(`${this.start} ${row.time}`, "YYYY-MM-DD HH:mm", "America/New_York");
      const hourEndEST = hourStartEST.clone().add(60, "minutes").add(59, "seconds");
      let unavailable = 0
      if (!type || type === 'break') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (!el.type || el.type === 'break') && overlaps
        });
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            unavailable = unavailable + duration
          })
        }
      } else if (type === 'performance') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'performance') && overlaps
        });
        console.log('break array perf', breakArray, unavailable)
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      } else if (type === 'engineering') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'engineering') && overlaps
        });
        console.log('break array perf', breakArray, unavailable)
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      } else if (type === 'meeting') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'meeting') && overlaps
        });
        console.log('break array meeting', breakArray, unavailable)
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      } else if (type === 'other') {
        const breakArray = row.breaks.filter(el => {
          const start = moment.tz(el.startTime, "America/New_York");
          const end = moment.tz(el.endTime, "America/New_York");

          const overlaps = start.isBefore(hourEndEST) && end.isAfter(hourStartEST);
          return (el.type === 'other' || el.type === 'offSupport') && overlaps
        });
        console.log('break array other', breakArray, unavailable)
        if (breakArray.length > 0) {
          breakArray.forEach(el => {
            const originalStart = moment.tz(el.startTime, "America/New_York");
            const originalEnd = moment.tz(el.endTime, "America/New_York");

            // Clip the break to the hour block
            const clippedStart = moment.max(originalStart, hourStartEST);
            const clippedEnd = moment.min(originalEnd, hourEndEST);
            console.log('clipped', clippedStart, clippedEnd, hourEndEST, hourStartEST, type)
            const duration = clippedEnd.diff(clippedStart, "minutes");
            console.log('duration', duration, unavailable)
            unavailable = unavailable + duration
          })
        }
      } else if (type === 'active') {
        console.log('351111', row)
        unavailable = row.availability ? row.availability * 60 : 60
      }
      console.log('unavailable', unavailable)
      return unavailable.toString().includes('.') ? unavailable.toFixed(2) : unavailable
    },
    getOffDeskMin(row) {
      let text = '';
      row.date = this.start
      if (this.getBreakMin(row, 'performance') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'performance') > 0}">Performance <i class="fa fa-bolt text-warning"></i>: <span class="${this.getBreakMin(row, 'performance') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'performance')}</span></span><br>`;
      }
      if (this.getBreakMin(row, 'engineering') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'engineering') > 0}">Engineering <i style="color: saddlebrown" class="fa fa-laptop"></i>: <span class="${this.getBreakMin(row, 'engineering') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'engineering')}</span></span><br>`;
      }
      if (this.getBreakMin(row, 'break') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'break') > 0}">Break <i style="color: saddlebrown" class="fa fa-coffee"></i>: <span class="${this.getBreakMin(row, 'break') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'break')}</span></span><br>`;
      }
      if (this.getBreakMin(row, 'meeting') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'meeting') > 0}">Meeting <i style="color: grey" class="fa fa-headphones"></i>: <span class="${this.getBreakMin(row, 'meeting') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'meeting')}</span></span><br>`;
      }
      if (this.getBreakMin(row, 'other') > 0) {
        text += `<span v-if="${this.getBreakMin(row, 'other') > 0}">Other <i style="color: black" class="fa fa-wrench"></i>: <span class="${this.getBreakMin(row, 'other') > 0 ? 'fw-600' : ''}">${this.getBreakMin(row, 'other')}</span></span><br>`;
      }
      text += `<span >Active 👨‍💻: <span class="fw-600">${row.availability ? row.availability * 60 : 60}</span></span><br>`;
      return text;
    },
    currentDay(dates = moment().tz('America/New_York').format('YYYY-MM-DD')) {
      let date = moment(dates, "YYYY-MM-DD");
      return date.format('dddd');
    },
    getBreakMinutesPerDays(breaks = []) {
      const totalsByType = {};

      breaks.forEach(entry => {
        const start = moment(entry.startTime);
        const end = moment(entry.endTime);
        const durationMinutes = end.diff(start, 'minutes');
        if (!entry.type) {
          entry.type = 'break';
        }
        if (!totalsByType[entry.type]) {
          totalsByType[entry.type] = 0;
        }

        totalsByType[entry.type] += durationMinutes;
      });

// Optionally convert to hours (with decimals)
      const hoursByType = {};
      for (const type in totalsByType) {
        hoursByType[type] = (totalsByType[type] / 60).toFixed(2); // 2 decimal places
      }
      return hoursByType;
    },
    getAdminTotalStats(row) {
      const {email} = row;
      console.log('email', email)
      let tickets_handled = 0
      let count_replies = 0
      let monitors_handled = 0
      for (const stats of this.allAdminStats) {
        const {type, hoursArray} = stats;
        // console.log('type', hoursArray)
        if (type === 'monitor') {
          hoursArray.map(el => {
            if (el.staff) {
              const monitorObj = el.staff.find(st => st.email === email)
              if (monitorObj) {
                monitors_handled += monitorObj.count
                console.log(monitors_handled)
              }
            }

          })
        } else if (type === 'ticket') {
          hoursArray.map(el => {
            if (el.staff) {
              const ticketObj = el.staff.find(st => st.replier_email === email)
              if (ticketObj) {
                tickets_handled += ticketObj.tickets_handled
                count_replies += ticketObj.count_replies
              }
            }

          })
        }
      }
      return {tickets_handled, count_replies, monitors_handled};
    },
    async fetchData() {
      this.oneDayStats = []
      this.sevenDayStats = []
      this.allAdminStats = []
      console.log(this.rangeLabel.length)
      if (this.rangeLabel.length === 0) return true;
      if (this.rangeLabel.length === 1) {
        const query = await db.collection('dashboardStats').where('date', '==', this.start).get();
        if (query.size) {
          query.forEach((doc) => {
            const row = doc.data();
            this.allAdminStats.push(row)
            const {hoursArray, type} = row;
            console.log('type', type, hoursArray);
            hoursArray.forEach(day => {
              const mainObj = this.oneDayStats.find(el => el.time === day.time)
              console.log('mainObj', mainObj)
              if (mainObj) {
                const ticketStatsObj = type === 'ticket' && hoursArray ? hoursArray.map(el => el.availableStaff && !!el.availableStaff.find(el1 => el1.email === this.selectedAdmin.email) && el.time === day.time ? {...el.staff.find(el1 => el1.replier_email === this.selectedAdmin.email), ...el.availableStaff.find(el => el.email === this.selectedAdmin.email)} : null).filter(Boolean) : null
                const monitorStatsObj = type === 'monitor' && hoursArray ? hoursArray.map(el => el.staff && !!el.staff.find(el1 => el1.email === this.selectedAdmin.email) && el.time === day.time ? el.staff.find(el1 => el1.email === this.selectedAdmin.email) : null).filter(Boolean) : null
                console.log('monitorStatsObj', monitorStatsObj)
                console.log('ticketStatsObj', ticketStatsObj)
                if (ticketStatsObj && ticketStatsObj.length > 0) {
                  mainObj.ticketStats = ticketStatsObj[0]
                } else if (monitorStatsObj && monitorStatsObj.length > 0) {
                  mainObj.monitorStats = monitorStatsObj[0]
                }
              } else {
                const obj = {
                  time: day.time,
                }
                const ticketStatsObj = type === 'ticket' && hoursArray ? hoursArray.map(el => el.availableStaff && !!el.availableStaff.find(el1 => el1.email === this.selectedAdmin.email) && el.time === day.time ? {...el.staff.find(el1 => el1.replier_email === this.selectedAdmin.email), ...el.availableStaff.find(el => el.email === this.selectedAdmin.email)} : null).filter(Boolean) : null
                const monitorStatsObj = type === 'monitor' && hoursArray ? hoursArray.map(el => el.staff && !!el.staff.find(el1 => el1.email === this.selectedAdmin.email) && el.time === day.time ? el.staff.find(el1 => el1.email === this.selectedAdmin.email) : null).filter(Boolean) : null
                console.log('monitorStatsObj 149', monitorStatsObj)
                console.log('ticketStatsObj 149', ticketStatsObj)
                if (ticketStatsObj && ticketStatsObj.length > 0) {
                  obj.ticketStats = ticketStatsObj[0]
                } else if (monitorStatsObj && monitorStatsObj.length > 0) {
                  obj.monitorStats = monitorStatsObj[0]
                }
                this.oneDayStats.push(obj)
              }
            })
          })
        }
      } else if (this.rangeLabel.length <= 30) {
        const query = await db.collection('dashboardStats').where('date', '>=', this.start).where('date', '<=', this.end).get();
        console.log('query', query.size)
        if (query.size) {
          query.forEach((doc) => {
            const row = doc.data();
            this.allAdminStats.push(row)
            const {hoursArray, type, date} = row;
            console.log('type', type, hoursArray);
            const existingObj = this.sevenDayStats.find(el => el.date === date)
            if (existingObj) {
              if (type === 'monitor') {
                hoursArray.forEach(day => {
                  if (day.staff) {
                    const staff = day.staff.find(el => el.email === this.selectedAdmin.email)
                    if (staff) {
                      existingObj.monitors_handled += staff.count;
                    }
                  }
                })
              } else if (type === 'ticket') {
                hoursArray.forEach(day => {
                  const requiredObj = day.staff ? day.staff.find(el => el.replier_email === this.selectedAdmin.email) : null
                  console.log(date, requiredObj, day.time, type)
                  if (requiredObj) {
                    existingObj.tickets_handled += requiredObj.tickets_handled;
                    existingObj.count_replies += requiredObj.count_replies;
                  }
                  if (day.availableStaff) {
                    const breaksArr = day.availableStaff.find(el => el.email === this.selectedAdmin.email);
                    if (breaksArr && breaksArr.breaks.length > 0) {
                      if (!existingObj.breaks || existingObj.breaks.length === 0) {
                        existingObj.breaks = []
                      }
                      existingObj.breaks = [...existingObj.breaks, ...breaksArr.breaks]
                      existingObj.breaks = existingObj.breaks.filter((item, index, self) =>
                              index === self.findIndex(other =>
                                  item.startTime === other.startTime
                              )
                      );

                    }
                  }
                  if (day.availableStaff) {
                    if (!existingObj.modes) {
                      existingObj.modes = {active: 0, performance: 0, engineering: 0, breaks: 0, other: 0}
                    }
                    console.log('46888888', existingObj.modes.active, typeof (this.getBreakMin({
                      date,
                      time: day.time, ...day.availableStaff.find(el => el.email === this.selectedAdmin.email)
                    }, 'active')))
                    const activeMode = this.getBreakMin({time: day.time, ...day.availableStaff.find(el => el.email === this.selectedAdmin.email)}, 'active')
                    if (activeMode) {
                      console.log('activeMode', parseInt(activeMode))
                      existingObj.modes.active = existingObj.modes.active + parseInt(activeMode)
                    }
                  }
                })
              }
            } else {
              const obj = {
                breaks: [],
                date,
                tickets_handled: 0,
                count_replies: 0,
                monitors_handled: 0,
                modes: {active: 0, performance: 0, engineering: 0, breaks: 0, other: 0}
              };
              if (type === 'monitor') {
                hoursArray.forEach(day => {
                  if (day.staff) {
                    const staff = day.staff.find(el => el.email === this.selectedAdmin.email)
                    if (staff) {
                      obj.monitors_handled += staff.count;
                    }
                  }
                })
              } else if (type === 'ticket') {
                hoursArray.forEach(day => {
                  console.log('day', day)
                  const requiredObj = day.staff ? day.staff.find(el => el.replier_email === this.selectedAdmin.email) : null
                  if (requiredObj) {
                    obj.tickets_handled += requiredObj.tickets_handled;
                    obj.count_replies += requiredObj.count_replies;
                  }
                  if (day.availableStaff) {
                    const breaksArr = day.availableStaff.find(el => el.email === this.selectedAdmin.email);
                    if (breaksArr && breaksArr.breaks.length > 0) {
                      obj.breaks = breaksArr.breaks
                    }
                  }
                  if (day.availableStaff) {
                    console.log('46888888', obj.modes.active, typeof (this.getBreakMin({
                      date,
                      time: day.time, ...day.availableStaff.find(el => el.email === this.selectedAdmin.email)
                    }, 'active')))
                    const activeMode = this.getBreakMin({
                      date,
                      time: day.time, ...day.availableStaff.find(el => el.email === this.selectedAdmin.email)
                    }, 'active')
                    if (activeMode) {
                      console.log('activeMode', parseInt(activeMode))
                      obj.modes.active = obj.modes.active + parseInt(activeMode)
                    }
                  }
                })
              }
              this.sevenDayStats.push(obj)
            }
          })
        }
      }
      this.initChart()
    },
    calculateTotalDays(startDate, endDate) {
      if (!endDate) {
        return
      }
      let start = new Date(startDate);
      let end = new Date(endDate);
      let dateArray = [];

      while (start <= end) {
        dateArray.push(start.toISOString().split('T')[0]); // Format as YYYY-MM-DD
        start.setDate(start.getDate() + 1); // Move to next day
      }
      dateArray = dateArray.filter(el => {
        const obj = this.selectedAdmin.shifts[this.currentDay(el)]
        return obj && obj.type
      })
      console.log(dateArray);
      this.rangeLabel = dateArray;
    },
    updateRangeLabel() {
      if (!this.start || !this.end) return;

      const from = new Date(this.start);
      const to = new Date(this.end);

      const diffTime = Math.abs(to - from);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (from.toDateString() === to.toDateString()) {
        this.rangeLabel = '1 Day';
      } else if (diffDays === 30) {
        this.rangeLabel = '30 Days';
      } else if (diffDays > 30) {
        const diffMonths = to.getMonth() - from.getMonth() + (12 * (to.getFullYear() - from.getFullYear()));
        this.rangeLabel = diffMonths > 1 ? `${diffMonths} Months` : '1 Month';
      } else {
        this.rangeLabel = `${diffDays} Days`;
      }
    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    load(staff) {
      Object.assign(this.$data, this.$options.data.call(this));
      this.staff = staff
      this.xCategories = this.staff.map(el => `${el.firstName} ${el.lastName}`)
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      $('#perStaffStats').modal('show');
    }
  }
}
</script>


<style lang="scss" scoped>

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}

.admin-card {
  padding: 20px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: 0.3s;
}

.card {
  transition: all 0.3s ease-in-out;
  border-radius: 12px;
}

.card:hover {
  transform: translateY(-5px) scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
</style>